module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Finstagram.a3c11b46.svg";